import { ListItem ,Tooltip} from "@mui/material";
import { useState, useRef, useEffect } from "react";
import Icons from "../../icons";
import IconButton from "../../toolkit/IconButton";
import SideMenuPopup from "./SideMenuPopup";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material";

const SideMenusIcons = "/side-menu-icons.json";

export default function SideMenuItemWithSubMenu({
  item,
  activeItem,
  setActiveItem,
}) {
  const location = useLocation();
  const anchorEl = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  function onMouseEnter() {
    setShowPopup(true);
  }

  function onMouseLeave() {
    setShowPopup(false);
  }

  useEffect(() => {
    if (
      !!item.sideMenus.find((i) => `/${i.actionName}` === location.pathname)
    ) {
      setActiveItem(item.menuName);
    }
  }, [location, item]);

  const handleCloseTooltip = () => {
    setShowPopup(true);
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <ListItem
      disableGutters
      sx={{
        justifyContent: "center",
      }}
      onMouseLeave={onMouseLeave}
    >
          <Tooltip title={item.menuDisplayname == "My Account"?"Settings":item.menuDisplayname }   placement="right"  arrow >

      <IconButton
        elRef={anchorEl}
        Icon={Icons[item.icon]}
        active={item.menuName === activeItem}
        onClick={onMouseEnter}
     
      />
          </Tooltip>
      <SideMenuPopup
        title={item.menuDisplayname}
        items={item.sideMenus}
        anchorEl={anchorEl.current}
        showPopup={showPopup}
        propagatePopupClose={() => setShowPopup(false)}
      />
    </ListItem>

  );
}
